var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRaiseHandOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.77,4.65a3,3,0,0,0-.61.08v0a2.69,2.69,0,0,0-5.11-1.2,2.53,2.53,0,0,0-.91-.17A2.7,2.7,0,0,0,8.44,6v4.86a2.7,2.7,0,0,0-4.58,2.86C6.57,19.45,8.51,22,12.8,22a7.68,7.68,0,0,0,7.67-7.68v-7A2.71,2.71,0,0,0,17.77,4.65Zm.62,9.67a5.6,5.6,0,0,1-5.59,5.6c-3,0-4.37-1.4-7.07-7.1l0-.07a.63.63,0,0,1,.22-.85.63.63,0,0,1,.85.23l1.82,3.15a1,1,0,0,0,1.17.49,1.06,1.06,0,0,0,.77-1V6a.62.62,0,0,1,.62-.62.61.61,0,0,1,.61.62v5.64h2.09v-7a.62.62,0,1,1,1.23,0v7h2.09V7.35a.61.61,0,0,1,.61-.61.61.61,0,0,1,.62.61Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaiseHandOn);
export default __webpack_public_path__ + "static/media/raise-hand-on.f615aa6d6b4eeae31ec731d82b3c7b42.svg";
export { ForwardRef as ReactComponent };